import { Component } from '@angular/core';
import { CommonAguPersonEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Agu Persons') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-commonaguperson-form',
    templateUrl: './commonaguperson.form.component.html'
})
export class CommonAguPersonFormComponent extends BaseFormComponent {
    public record!: CommonAguPersonEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'memberProfiles', sectionName: 'Member Profiles', isExpanded: false }
        ]);
    }
}

